import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const SettingsPage: React.FC = () => {
  const navigate = useNavigate()

  // Redirect to Profile page Security tab
  useEffect(() => {
    navigate('/profile', { replace: true, state: { tab: 'security' } })
  }, [navigate])

  return null
}
